var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('app-banner',{attrs:{"role":"banner"}}),_c('breadcrumb',{attrs:{"to":_vm.breadcrumbTo,"useOffset":false}}),_c('div',{key:"connecting",staticClass:"transition-root"},[_c('div',{staticClass:"row"},[_c('loading-indicator',[_vm._v("Forbinder..")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }